<template>
  <div v-if="screenWidth >= 992" class="registration-control" @click="isRegistration">
    <svg class="registration-control__icon">
      <use xlink:href="#svg-user"></use>
    </svg>
    <!--    <span v-if="!result.authInfo.isAuthorized" class="registration-control__text">-->
    <!--      {{ result.messages.login_cabinet }}-->
    <!--    </span>-->
    <!--    <span v-else class="registration-control__profile">-->
    <!--      <span class="registration-control__name">-->
    <!--        {{ result.authInfo.user_name }}-->
    <!--      </span>-->
    <!--    </span>-->
    <!--    <a-->
    <!--      v-if="result.authInfo.isAuthorized"-->
    <!--      href="?logout=yes"-->
    <!--      class="registration-control__log-out"-->
    <!--      @click.prevent.stop="logOut"-->
    <!--    >-->
    <!--      {{ result.messages.exit }}-->
    <!--    </a>-->
  </div>
</template>
<script>
import { mapState } from 'vuex';
import useModal from '@use/useModal/useModal';
import EnterCabinet from '@components/Cabinet/EnterCabinet/EnterCabinet.vue';
import useScreenWidth from '@use/useScreenWidth';

export default {
  name: 'RegistrationControl',
  data() {
    return {
      modal: useModal(),
      screenWidth: useScreenWidth(),
    };
  },
  computed: {
    ...mapState({
      result: ({ personal }) => personal.data,
    }),
  },
  mounted() {
    // console.log(this.obData);
    // if (App.debug) console.log('Component: registration-control', this.result);
  },
  created() {
    if (this.$store) {
      this.$store.commit('personal/setData', this.result);
    }
  },
  methods: {
    isRegistration() {
      if (!this.result.authInfo.isAuthorized) {
        // close mobile menu
        const menu = document.querySelector('.close-menu');
        if (this.screenWidth <= 992 && menu) {
          menu.click();
        }
        this.modal.show(
          EnterCabinet,
          {},
          {
            width: '440px',
          }
        );
      } else {
        location.href = `/${this.result.personalCabPath}`;
      }
    },
    logOut({ target }) {
      /**
       * before log out clear session storage
       */
      window.sessionStorage.removeItem('phoneValidityRejected');
      window.location.href = target.href;
    },
  },
};
</script>
<style lang="scss" scoped>
.registration-control {
  display: flex;
  align-items: center;
  height: 100%;
  //padding: 0 10px 0 0;
  margin-right: 24px;
  cursor: pointer;
  &:hover {
    .registration-control__icon {
      fill: var(--text-colour-secondary);
    }
    .registration-control__name,
    .registration-control__text {
      color: var(--text-colour-secondary);
    }
  }
  &__icon {
    display: block;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    transition: 0.2s linear fill;
    fill: #191918;
  }
  &__name,
  &__text {
    font-size: rem(14);
    margin-left: 10px;
    font-weight: 500;
    transition: 0.2s linear color;
  }
  &__log-out {
    display: flex;
    align-items: center;
    margin-left: 15px;
    font-weight: 500;
  }
}
</style>
